import React from "react";
import FormPdfDocument from "../FormPdfDocument";

const FacialPdf = ({ formData }) => (
  <FormPdfDocument
    formData={formData}
    headerTitle="FACIAL"
    page1SubTitle="Personal Information + History"
    serviceQuestion="Have you had a professional facial before?"
    page2ProductLabel="Skincare products:"
    agreementText="I have read and fully understand all information in this agreement. I consent to the agreement and to the facial treatment."
  />
);

export default FacialPdf;
